module.exports = __webpack_public_path__ + "87ee0791c29d03b2fd7b60f4ebe4bbd6.svg";